import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransitDoPaymentsService } from 'src/app/services/transit/transit-do-payments.service';

@Component({
  selector: 'app-transit-do-payments-select-bl',
  templateUrl: './transit-do-payments-select-bl.component.html',
  styleUrls: ['./transit-do-payments-select-bl.component.css']
})
export class TransitDoPaymentsSelectBlComponent implements OnInit{
  page: number = 1;
  count: number = 0;

  bills_of_lading: any[] = [];
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public modalErrorMessage: string | null = null;
  searchText: string = '';
  public isLoading: boolean = false;
  public isInProgress: boolean = false;
  form!: FormGroup;
  submitted: boolean = false;
  @ViewChild('UpdatePriceModal') modalElement!: ElementRef;
  public selectedBlNo: string | null = null;
  public selectedBlId: string | null = null;

  constructor(
    private transitDoPaymentsService: TransitDoPaymentsService,
    private formBuilder: FormBuilder
  )
  {
    this.form = this.formBuilder.group({
      src_currency: ['', Validators.required],
      do_amount:['',Validators.required]
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.getBillsOflading();
  }

  getBillsOflading(): void {
    this.transitDoPaymentsService.getBLs()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.bills_of_lading = response.data
          this.isLoading = false;
        }else{
          this.errorMessage=response.message;
          this.isLoading = false;
          this.successMessage=null;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.successMessage=null;
        this.isLoading = false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
    this.getBillsOflading();
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  openModal(bl_id:string,bl_no:string){
    this.selectedBlNo=bl_no;
    this.selectedBlId=bl_id;

    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('show');
    }
  }

  closeModal():void {
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  handleSubmit():void {
    this.submitted = true;
    this.isInProgress=true;

    if (this.form.valid) {
      if(Number.isNaN(Number(this.form.value.do_amount))) {
        this.submitted = false;
        this.isInProgress=false;
        this.modalErrorMessage="Invalid D.O amount. Only numbers are allowed!";
      }else{
        const payload = {
          bl_no: this.selectedBlNo,
          src_currency: this.form.value.src_currency,
          amount: this.form.value.do_amount,
        };

        this.transitDoPaymentsService.postPayments(payload)
        .subscribe({
          next: (response) => {
            if(response.status==='success'){
              this.isInProgress=false;

              //Reset form
              this.form.patchValue({
                src_currency: "",
                do_amount: ""
              });
              this.submitted = false;

              this.closeModal(); //Close modal
              this.successMessage=response.message;

              // Refresh the list
              this.isLoading = true;
              this.getBillsOflading();
            }else{
              this.modalErrorMessage=response.message;
              this.isInProgress=false;
            }
          },
          error: (error) => {
             //Reset form
             this.form.patchValue({
              src_currency: "",
              do_amount: ""
            });
            this.submitted = false;

            this.closeModal(); //Close modal
            this.errorMessage=error;
            this.isInProgress=false;
          }
        });
      }
    }else{
      this.isInProgress=false;
    }
  }
}
